import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';

import PageHeading from 'components/PageHeading';
import TableSortCell from 'components/TableSortCell';
import TableActionCell from 'components/TableActionCell';
import TableCount from 'components/TableCount';
import PageHeadingButton from 'components/PageHeadingButton';

import { confirmAlert } from 'utils';

class CategoriesListPage extends React.PureComponent {
  handleSort = (sortName, sortDirection) => {
    return this.props.onSort({ sortName, sortDirection });
  };

  handleDelete = (id) => {
    const { onDelete } = this.props;
    confirmAlert({ okCb: () => onDelete(id) });
  };

  render() {
    const { items } = this.props.initialData;
    const { sortName, sortDirection } = this.props;
    return (
      <div>
        <PageHeading
          title="Categories"
          right={
            <PageHeadingButton link="/category-details">
              + New category
            </PageHeadingButton>
          }
        />
        <TableCount count={items.length} />
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableSortCell
                  title="Name"
                  sortName="name"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableSortCell
                  title="Parent category"
                  sortName="js:parentName"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.parentName}</TableCell>
                  <TableActionCell
                    link={`/category-details/${item.id}`}
                    icon="edit"
                  />
                  <TableActionCell
                    action={() => this.handleDelete(item.id)}
                    icon="delete"
                  />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

CategoriesListPage.propTypes = {
  initialData: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  sortName: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CategoriesListPage;
